import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HistoryActiveService } from './services/historyActive.service';
import { Subject } from 'rxjs/Subject';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { HttpClient } from '@angular/common/http';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { BatchService } from '../batch.service';
import { environment } from '../../../../../../environments/environment';
import { DatePipe } from '@angular/common';
import { ImageService } from '../../../../imageService';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
// @ts-ignore
import _ = require('lodash');
import { ExportService } from '../../../../../common/services/Export.service';

declare var $: any;

@Component({
  selector: 'app-historyActive',
  templateUrl: './historyActive.component.html',
  styleUrls: ['./historyActive.component.css'],
  providers: [HistoryActiveService, DatePipe],
})
export class HistoryActiveComponent implements OnInit {
  @ViewChild('select2Api') select2Api;
  @ViewChild('selectAgencyApi') selectAgencyApi;
  @ViewChild('returnStamp') returnStamp: ModalDirective;
  @ViewChild('returnStampList') returnStampList: ModalDirective;
  @ViewChild('cancelStamp') cancelStamp: ModalDirective;
  @ViewChild('editStamp') editStamp: ModalDirective;
  @ViewChild('returnStampBox') returnStampBox: ModalDirective;
  @ViewChild('editLog') editLog: ModalDirective;
  @ViewChild('importFile') importFile: ModalDirective;
  @ViewChild('buttonDistribution') buttonDistribution: ModalDirective;
  @ViewChild('boxStampDistribution') boxStampDistribution;

  @ViewChild('warningCancelActive') warningCancelActive: ModalDirective;

  @ViewChild('confirmCancelActive') confirmCancelActive: ModalDirective;

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  page_title = '';
  isDistribution: Boolean = false;
  isList: Boolean = true;
  isReadmore: Boolean = false;
  stasitic: any;
  reason = '';
  lotem: string;
  addContent = '';
  listBatches = [
    {
      label: 'Lo 1',
      value: 1,
    },
    {
      label: 'Lo 2',
      value: 2,
    },
  ];
  data = [];
  data_stamp = [];

  total_data: 0;
  total_stamp: 0;
  item_active: any;
  pageIndex = 1;
  page_size = 10;
  totalPage: number;
  item_detail: any;
  item_detail2: any;
  dataSelectFromAgency = '';
  dataSelectToAgency = '';
  unsubscribe$ = new Subject<void>();
  query;
  queryStamp = {};
  public fromArea: Array<any> = [];
  public toArea: Array<any> = [];
  formStamp = this.fb.group({
    code: null,
    type: null,
    lotId: null,
    productId: null,
    status: null,
  });
  pageIndexStamp = 1;
  pageSizeStamp = 10;
  supplier = [];
  historyId;
  type_stamp = [];
  status_stamp = [];
  loading_left = false;
  getCities = [];
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];
  loading_stamp = false;
  disabledConfirm = false;
  disabledReturnBox = false;
  disabledTakeBack = false;
  singleReturnBox = {};
  singleTakeBack = {};
  userIdCreated;
  returnStampBoxImages: any = [];
  boxTypeList: any = [];
  formCratingBatch: FormGroup = this.fb.group({
    name: [''],
    note: [''],
  });
  formWithdrawal: FormGroup = this.fb.group({
    stampCode: ['', [Validators.required]],
  });
  isDownImport: boolean = false;
  batchId: any;
  /***[2-11-2022]-Tuanba: button phân phối**/
  checkButtonDistri: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    public historyActiveService: HistoryActiveService,
    public router: Router,
    private upload: UploadService,
    private modalService: BsModalService,
    private batchService: BatchService,
    private activatedRoute: ActivatedRoute,
    public httpClient: HttpClient,
    public datepipe: DatePipe,
    private imageService: ImageService,
    private exportService: ExportService,
    public translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.isList = true;

    this.translate.onLangChange.subscribe(() => {
      this.initTranslate();
    });
    this.initTranslate();

    // End Select search
    this.initSelect2();
  }

  initTranslate() {
    this.page_title = this.translate.instant('LICH_SU_KICH_HOAT_GAN_SAN_PHAM');
    this.type_stamp = [
      {
        label: this.translate.instant('TEM_THUNG'),
        value: 0,
      },
      {
        label: this.translate.instant('TEM_SAN_PHAM'),
        value: 1,
      },
    ];
    this.status_stamp = [
      {
        label: this.translate.instant('DA_XAC_NHAN'),
        value: 1,
      },
      {
        label: this.translate.instant('CHUA_XAC_NHAN'),
        value: 0,
      },
    ];

    // Cập nhật lại tên dịch vụ trong data_stamp khi chuyển ngôn ngữ
    const serviceTranslateMap = {
      1: 'DICH_VU_CHONG_GIA',
      2: 'DICH_VU_BAO_HANH',
      3: 'DICH_VU_TRAN_HANG',
      5: 'DICH_VU_DINH_DANH'
    };
    if (this.data_stamp && this.data_stamp.length > 0) {
      this.data_stamp = this.data_stamp.map(item => {
        if (item.listServices && item.listServices.length > 0) {
          item.listServices = item.listServices.map(svc => {
            if (serviceTranslateMap[svc.id]) {
              svc.name = this.translate.instant(serviceTranslateMap[svc.id]);
            }
            return svc;
          });
        }
        return item;
      });
    }

    this.initSelect2();
  }

  initSelect2() {
    $('#fromArea').select2({ placeholder: this.translate.instant('KHU_VUC_XUAT'), allowClear: true });
    $('#toArea').select2({ placeholder: this.translate.instant('KHU_VUC_NHAN'), allowClear: true });
    $('#confirmationStatus').select2({
      placeholder: this.translate.instant('TRANG_THAI_XAC_NHAN'),
      allowClear: true,
    });
    $('#alertStatus').select2({
      placeholder: this.translate.instant('TINH_TRANG_CANH_BAO'),
      allowClear: true,
    });
    $('#activeStatus').select2({
      placeholder: this.translate.instant('TRANG_THAI_KICH_HOAT_TEM'),
      allowClear: true,
    });
    $('#approvedFile').select2({
      placeholder: this.translate.instant('TRANG_THAI_GAN_SAN_PHAM'),
      allowClear: true,
    });
    $('#userIdCreated').select2({
      placeholder: this.translate.instant('NGUOI_THUC_HIEN'),
      allowClear: true,
      minimumInputLength: 1,
      ajax: {
        delay: 1500,
        url: `${environment.qrcode_url}/user/search`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          return {
            keyword: params.term || '',
            page: 1,
            page_size: 50,
          };
        },
        processResults: function (data) {
          if (data.data !== null) {
            return {
              results: data.data.items.map((item) => {
                return {
                  text: item.name,
                  id: item.userId,
                };
              }),
            };
          }
          return [];
        },
      },
    });
    $('.slt-batchstamp').select2({
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });

    // @ts-ignore
    this.loading_left = true;
    const agencyData = JSON.parse(localStorage.getItem('agencyId'));
    // tslint:disable-next-line:prefer-const
    if (agencyData) {
      const newOption = new Option(
        agencyData.name,
        agencyData.id,
        false,
        false
      );
      $('#distributionAgent').append(newOption).trigger('change');
      $('#classify').val('0').trigger('change');
      localStorage.removeItem('agencyId');
    }
    this.getFromArea();
    this.getListBoxType();


    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.batchId = params['id'];
      }
    );
  }

  productId1;

  changeProduct(event) {
    this.productId1 = event ? event : null;
  }

  listImageDistribution: any = [];

  search() {
    this.pageIndex = 1;
    this.loading_left = true;
    this.fetch();
  }

  reset() {
    console.log('reset');
    localStorage.removeItem('agencyId');
    this.pageIndex = 1;
    $('.serial').val(null).trigger('change');
    $('.codeSMS').val(null).trigger('change');
    $('.noteTemp').val(null).trigger('change');
    $('#activeStatus').val(null).trigger('change');
    $('#approvedFile').val(null).trigger('change');
    $('.timePicker').val(null).trigger('change');
    $('#batchstamp').val(null).trigger('change');
    $('#userIdCreated').val(null).trigger('change');
    this.loading_left = true;

    this.fetch();
  }

  loadDataChild($event: any) {
    this.fetch();
  }

  fetch() {
    const timePicker = $('.timePicker');
    const from_convert = moment(timePicker.val().split('-')[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const to_convert = moment(timePicker.val().split('-')[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
    console.log('v1', from_convert);
    console.log('v', to_convert);
    this.query = {
      serial: $('.serial').val(),
      sms: $('.codeSMS').val(),
      note: $('.noteTemp').val(),
      productId: this.productId1 ? this.productId1 : '',
      activeStatus: $('#activeStatus').val(),
      approvedFile: $('#approvedFile').val(),
      batchId: $('.slt-batchstamp').val() ? $('.slt-batchstamp').val() : '',
      createdBy: $('#userIdCreated').val() ? $('#userIdCreated').val() : '',
      from: timePicker.val().split('-')[0] ? from_convert : '',
      to: timePicker.val().split('-')[1] ? to_convert : '',
      page: this.pageIndex,
      pageSize: this.page_size,
    };

    // this.addressService.getCities().subscribe(val => {
    // console.log('val', this.getCities)

    this.historyActiveService.getBatchHistory(this.batchId, this.query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data = res.data.totalElement;
          // console.log(' this.total_data',  this.total_data)
          const listDistribute = [...res.data.items];
          // res.data.items.map((item, key) => {
          //   this.getCities.map((val2) => {
          //     if (item.fromProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].fromProvinceId = val2.name;
          //     }
          //     if (item.toProvinceId === val2.id) {
          //       // tslint:disable-next-line:no-unused-expression
          //       listDistribute[key].toProvinceId = val2.name;
          //     }
          //   });
          // });
          this.data = listDistribute;
          console.log('res11', this.data);

          if (this.data.length > 0) {
            this.data.map((item, i) => {
              if (i === 0) {
                this.viewDetail(item, i);
              }
            });
          }
          this.loading_left = false;
          return;
        }
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(res.message, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (err) => {
        this.total_data = 0;
        this.loading_left = false;
        this.data = [];
        this.toastr.warning(err.message, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  getFromArea() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.fromArea = citiesList;
      this.toArea = citiesList;
      this.getCities = res.data.cities;

      this.fetch();
    });
  }

  changeReadMore(e) {
    this.isReadmore = e;
  }

  listImage = [];
  firstImage: any;
  /** [2-11-2022]-Tuanba: Validate button phân phối **/
  public errorButtonValidate = '';

  changeDistribution() {
    if (this.loading_left) {
      this.toastr.warning(this.translate.instant('DANG_TAI_DU_LIEU'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.isDistribution = true;
      this.isList = false;
      this.isWithdrawal = false;
      this.resetFormWithdrawal()
    }
  }

  // load page danh sach lịch sử đóng thùng
  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loading_left = true;

      this.fetch();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )

    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    this.loading_left = true;

    this.fetch();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loading_left = true;

      this.fetch();
    }
  }

  // ============== danh sach tem ========================== //
  loadListStamp(id) {
    // this.queryStamp
    this.loading_stamp = true;
    this.queryStamp = {
      page: this.pageIndexStamp,
      pageSize: this.pageSizeStamp,
    };
    console.log('this.queryStamp', this.queryStamp)
    this.historyActiveService
      .historyBatch(this.batchId, id, this.queryStamp)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            console.log(99999, res)

            this.data_stamp = res.data.items.map((item: any) => {
              let tmpItem = item;
              tmpItem.serialStart = this.formatSerial(
                item.idStart,
                item.prefix
              );
              tmpItem.serialEnd = this.formatSerial(item.idEnd, item.prefix);
              return tmpItem;
            });

            if (this.data_stamp.length > 0) {
              for (let i = 0; i < this.data_stamp.length; i++) {
                if (this.data_stamp[i].services) {
                  var listServices: any = [];
                  var services = this.data_stamp[i].services.split(',');
                  for (let j = 0; j < services.length; j++) {
                    switch (services[j]) {
                      case '1': {
                        listServices.push({
                          id: 1,
                          name: this.translate.instant('DICH_VU_CHONG_GIA')
                        })
                        break;
                      }
                      case '2': {
                        listServices.push({
                          id: 2,
                          name: this.translate.instant('DICH_VU_BAO_HANH')
                        })
                        break;
                      }
                      case '3': {
                        listServices.push({
                          id: 3,
                          name: this.translate.instant('DICH_VU_TRAN_HANG')
                        })
                        break;
                      }
                      case '5': {
                        listServices.push({
                          id: 5,
                          name: this.translate.instant('DICH_VU_DINH_DANH')
                        })
                        break;
                      }
                    }
                  }

                }
              }
              this.data_stamp = this.data_stamp.map(z => {
                return { ...z, listServices }
              });
            }
            // this.data_stamp.map(console.log);
            this.total_stamp = res.data.pagination.totalElements;
            this.refeshCheckAll();
            this.loading_stamp = false;
            return;
          }
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        },
        (error) => {
          this.data_stamp = [];
          this.total_stamp = 0;
          this.loading_stamp = false;
        }
      );
  }

  refeshCheckAll() {
    if (this.data_stamp && this.data_stamp.length) {
      // tslint:disable-next-line:max-line-length
      this.isCheckAll = this.data_stamp.every(
        (item) =>
          this.listOfChecked[
          item.stampId +
          '-' +
          item.stampStatus +
          '-' +
          item.stampType +
          '-' +
          item.prefix +
          '-' +
          item.idStart +
          '-' +
          item.idEnd
          ]
      );
      return;
    }
    this.isCheckAll = false;
  }

  searchStamp() {
    this.pageIndexStamp = 1;
    // this.loadListStamp();
  }

  resetStamp() {
    this.formStamp.reset();
    $('.stampCode').val('').trigger('change');
    $('#typeTemp').val(null).trigger('change');
    $('#productId').val(null).trigger('change');
    $('#confirmation').val(null).trigger('change');
    // $('#stampStatus').val(null).trigger('change');
    this.pageIndexStamp = 1;
    // this.loadListStamp();
  }

  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_stamp.map((item) => {
        // tslint:disable-next-line:max-line-length
        this.listOfChecked[
          item.stampId +
          '-' +
          item.stampStatus +
          '-' +
          item.stampType +
          '-' +
          item.prefix +
          '-' +
          item.idStart +
          '-' +
          item.idEnd
        ] = true;
      });
      this.listIdChecked();
      this.checkDisableButton();

      return;
    }
    this.data_stamp.map((item) => {
      // tslint:disable-next-line:max-line-length
      this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
      ] = false;
      this.listIdChecked();
      this.checkDisableButton();
    });
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;

    this.listOfChecked[value] = checked;
    // tslint:disable-next-line:max-line-length
    this.isCheckAll = this.data_stamp.every(
      (item) =>
        this.listOfChecked[
        item.stampId +
        '-' +
        item.stampStatus +
        '-' +
        item.stampType +
        '-' +
        item.prefix +
        '-' +
        item.idStart +
        '-' +
        item.idEnd
        ]
    );
    this.listIdChecked();

    this.checkDisableButton();
  }

  resetCheckbox() {
    this.isCheckAll = false;
    this.listOfChecked = {};
    this.list_id = [];
    this.disabledConfirm = false;
    this.disabledReturnBox = false;
    this.disabledTakeBack = false;
  }

  checkDisableButton() {
    // check disable button
    const checkConfirm = [];
    const checkReturn = [];
    const checkTakeBack = [];
    this.list_id.map((res) => {
      const stampStatus = res.split('-')[1];
      const stamp = res.split('-')[0];
      // tslint:disable-next-line:radix
      if (parseInt(stampStatus) === 1) {
        console.log('stampStatus1', stampStatus);
        checkConfirm.push(stamp);
        checkTakeBack.push(stamp);
      } else {
        console.log('stampStatus2', stampStatus);

        checkReturn.push(stamp);
      }
    });

    this.disabledConfirm = checkConfirm.length > 0;
    this.disabledReturnBox = checkReturn.length > 0;
    this.disabledTakeBack = checkTakeBack.length > 0;
  }

  confirmAll(e?) {
    let body = {};

    if (e) {
      body = {
        listBundleId: [e],
      };
    } else {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_TEM'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      const list = [];
      this.list_id.map((res) => list.push(res.split('-')[0]));

      body = {
        listBundleId: list,
      };
    }

    console.log('this.listOfChecked', body);

    this.historyActiveService.confirm(body).subscribe(
      (res) => {
        console.log('res111kkk', res);
        if (res.code === 1) {
          this.isCheckAll = false;
          this.listOfChecked = {};
          this.list_id = [];
          // this.loadListStamp();

          this.toastr.success(
            this.translate.instant('XAC_NHAN_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              positionClass: 'toast-top-right',
              enableHtml: true,
            }
          );
          return;
        }
        this.toastr.warning(res.message, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      },
      (error) => {
        this.toastr.warning(error.message, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      }
    );
  }

  returnBox() {
    console.log(this.singleReturnBox, _.isEmpty(this.singleReturnBox));

    if (_.isEmpty(this.singleReturnBox)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_TEM'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStampBox.show();
  }

  loadingReturnStampBox: boolean = false;

  handleReturnStampBox() {
    console.log('this.list_id', this.list_id);
    if (this.addContent.trim().length === 0) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_LY_DO_TRA_HANG'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.addContent.trim().length > 255) {
      this.toastr.warning(this.translate.instant('BAN_DA_NHAP_QUA_255_KY_TU'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = {};
    // trả hàng nhiều
    if (_.isEmpty(this.singleReturnBox)) {
      const data = [];
      this.list_id.map((res) => {
        let arrSplit = res.split('-');
        const stampType = arrSplit[2];
        const idEnd = arrSplit[arrSplit.length - 1];
        const idStart = arrSplit[arrSplit.length - 2];
        const indexRemove = [0, 1, 2, arrSplit.length - 1, arrSplit.length - 2];
        const prefix = arrSplit
          .filter(function (value, index) {
            return indexRemove.indexOf(index) == -1;
          })
          .join('-');

        data.push({
          type: stampType,
          prefix: prefix,
          idStart: idStart,
          idEnd: idEnd,
          note: this.addContent,
          document: {
            items:
              this.returnStampBoxImages && this.returnStampBoxImages.length
                ? this.returnStampBoxImages
                : null,
          },
        });
      });
      body = {
        listData: data,
        transferId: this.historyId,
      };
    }
    // trả hàng đơn
    else {
      body = {
        transferId: this.historyId,
        listData: [
          {
            type: this.singleReturnBox['stampType'],
            prefix: this.singleReturnBox['prefix'],
            idStart: this.singleReturnBox['idStart'],
            idEnd: this.singleReturnBox['idEnd'],
            note: this.addContent,
            document: {
              items:
                this.returnStampBoxImages && this.returnStampBoxImages.length
                  ? this.returnStampBoxImages
                  : null,
            },
          },
        ],
      };
    }

    this.loadingReturnStampBox = true;
    this.historyActiveService.return(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            this.translate.instant('TRA_HANG_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          this.loadingReturnStampBox = false;
          setTimeout(() => {
            this.addContent = '';
            this.returnStampBoxImages = [];
            this.returnStampBox.hide();
            // this.loadListStamp();
          }, 200);
          return;
        }
        this.loadingReturnStampBox = false;
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
      },
      (error) => {
        this.loadingReturnStampBox = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  takeBack() {
    if (_.isEmpty(this.singleTakeBack)) {
      if (this.list_id.length <= 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_TEM'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
        return;
      }
    }
    this.returnStamp.show();
  }


  cancel() {
    this.cancelStamp.show();
  }

  showEdit() {
    this.editStamp.show();
  }

  onLoadingReturnStamp: boolean = false;

  handleReturnStamp() {
    console.log('this.list_id', this.list_id);
    return;
    let body = {};
    if (_.isEmpty(this.singleTakeBack)) {
      const data = [];
      this.list_id.map((res) => {
        const stampId = res.split('-')[0];
        data.push({
          bundleId: stampId,
        });
      });

      body = {
        datas: data,
        transferId: this.historyId,
      };
    } else {
      body = {
        datas: [this.singleTakeBack],
        transferId: this.historyId,
      };
    }
    // console.log("body", body);
    this.onLoadingReturnStamp = true;
    console.log(body);
    return
    this.historyActiveService.takeBack(body).subscribe(
      (res) => {
        if (res.code === 1) {
          this.list_id = [];
          this.listOfChecked = {};
          this.isCheckAll = false;
          this.toastr.success(
            this.translate.instant('THU_HOI_PHAN_PHOI_THANH_CONG') +
            `<div>${this.translate.instant('THANH_CONG')}: <b>${res.data.success}</b>, ${this.translate.instant('THAT_BAI')}: <b>${res.data.fail}</b></div>`,
            this.translate.instant('THANH_CONG'),
            {
              timeOut: 4000,
              enableHtml: true,
            }
          );
          setTimeout(() => {
            this.returnStamp.hide();
            // this.loadListStamp();
          }, 200);
          this.onLoadingReturnStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        this.onLoadingReturnStamp = false;
      },
      (error) => {
        this.onLoadingReturnStamp = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  onloadingCancelStamp: boolean = false;

  handleCancelStamp() {
    let body = {
      transferId: this.item_detail.historyId
    }
    this.onloadingCancelStamp = true;
    this.historyActiveService.cancelStamp(body).subscribe(
      (res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('HUY_GIAO_DICH_THANH_CONG'), this.translate.instant('THANH_CONG'), {
            timeOut: 4000,
            enableHtml: true,
          });
          setTimeout(() => {
            this.cancelStamp.hide();
            // this.loadListStamp();
            this.reset()
          }, 200);
          this.onloadingCancelStamp = false;
          return;
        }
        this.toastr.error(`${res.message}`, this.translate.instant('THAT_BAI'));
        this.onloadingCancelStamp = false;
      },
      (error) => {
        this.onloadingCancelStamp = false;
        this.toastr.error(`${error.message}`, this.translate.instant('THAT_BAI'));
      }
    );
  }

  prePageStamp() {
    this.pageIndexStamp = this.pageIndexStamp - 1;
    this.loadListStamp(this.item_detail2.batchActionId);
  }

  lastPageStamp() {
    if (this.pageIndexStamp * this.pageIndexStamp < this.total_stamp) {
      this.pageIndexStamp = this.pageIndexStamp + 1;
      this.loadListStamp(this.item_detail2.batchActionId);

    }
  }

  inputPageStamp(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexStamp) {
      this.pageIndexStamp = page;
      this.loadListStamp(this.item_detail2.batchActionId);
    }
  }

  // search serial
  searchInfoSerial(code: string) {
    this.router.navigate(['/find-stamp'], { queryParams: { code } });
  }

  formatSerial(id: any, prefix: string) {
    let serial_f: string = '';
    id = id.toString();
    if (id && prefix) {
      let pad = '000000';
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  // handle images when upload
  tusUploadReturnBoxImages = (item) => {
    const numberImages = item.target.files.length;
    for (const image of item.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = (<any>e.target).result;
        return this.upload.uploadImagesNew(fileData).subscribe((res) => {
          const image = {
            id: res.json().fileId,
            url: res.json().src,
          };
          this.returnStampBoxImages.push(image);
          console.log(this.returnStampBoxImages);
        });
      };
      reader.readAsArrayBuffer(image);
    }
  };

  // delete image upload
  deleteImage(index: number) {
    this.returnStampBoxImages.splice(index, 1);
  }

  changeGuaranteeDays(value) {
    console.log(value);
    if (this.currentLog) {
      // this.currentLog.guaranteeDays = value
    }
  }

  public guaranteeDays;
  public guaranteeDaysMax;
  public produceTime;
  public guaranteeDayMaxType;
  public guaranteeDayType
  currentLogId: any;
  currentLog: any;

  openModalEditLog(item) {
    this.currentLogId = item.id;
    this.guaranteeDays = item.guaranteeDays;
    this.guaranteeDayType = item.guaranteeDayType;
    this.guaranteeDaysMax = item.guaranteeDaysMax;
    this.guaranteeDayMaxType = item.guaranteeDayMaxType;
    this.produceTime = item.produceTime;
    console.log('id: ' + item);
    console.log(this.guaranteeDayType);
    this.editLog.show();
  }

  updateBatchLog() {

    let time = this.datepipe.transform(this.produceTime, 'dd-MM-y');
    // let time = moment(this.produceTime).format('DD-MM-YYYY');
    console.log('thoi gian ne: ' + time);
    console.log('aba: ' + this.guaranteeDays, this.guaranteeDaysMax, time, this.currentLogId, this.guaranteeDayMaxType, this.guaranteeDayType);
    let body = {
      currentLogId: this.currentLogId,
      produceTime: time, //Ngày sản xuất
      guaranteeDays: this.guaranteeDays, // Thời gian bảo hành
      guaranteeDayType: this.guaranteeDayType, // Kiểu thời gian bảo hành
      guaranteeDaysMax: this.guaranteeDaysMax,
      guaranteeDayMaxType: this.guaranteeDayMaxType,

    }
    if ((body.guaranteeDaysMax)) {
      if ((!body.produceTime || !body.guaranteeDays)) {
        this.toastr.error(this.translate.instant('THOI_GIAN_BAO_HANH_VA_NGAY_SAN_XUAT_KHONG_DUOC_DE_TRONG'), '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        })
        return;
      }
    }
    this.historyActiveService.updateLogBatch(body.currentLogId, body).subscribe((res) => {
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('CAP_NHAT_LOG_THANH_CONG'), this.translate.instant('THONG_BAO'), {
          timeOut: 500,
          positionClass: 'toast-top-right',
        });
        setTimeout(() => {
          this.fetch()
          this.closeModalEditLog();
        }, 2000);

        return;
      } else if (res.code == 400) {
        this.toastr.error(this.translate.instant('KHONG_CO_QUYEN_QUAN_LY_VOI_LO_TEM'), this.translate.instant('THONG_BAO'), {
          timeOut: 2000,
          positionClass: 'toast-bottom-right',
        })
        setTimeout(() => {
          this.fetch()
          this.closeModalEditLog();
        }, 2000);
      }
    },
      (error) => {
        console.log('error', error)
        this.toastr.error(error.message, this.translate.instant('CAP_NHAT_THANH_CONG'), {
          timeOut: 2000,
          positionClass: 'toast-top-right',
        });
        this.fetch()
        this.closeModalEditLog();
      }
    );


  }

  closeModalEditLog() {
    this.editLog.hide();
  }

  getListBoxType() {
    this.historyActiveService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }

  activeTab = 1;
  pageIndexWarningUser = 1;
  pageSizeWarningUser = 10;
  total_warning_user = 0;
  loadingUserWarning: boolean = false;
  data_warning_user = [];

  changeTab(event) {
    this.activeTab = event;
    if (event === 1) {
      // this.resetWarningAuto();
    }
    if (event === 2) {
      // this.resetInspection();
    }
    if (event === 3) {
      this.resetWarningUser();
    }
    // this.districts = [];
  }

  resetWarningUser() {
    this.pageIndexWarningUser = 1;
    // $("#Area3").val("").trigger("change");
    // $("#Agency3").val("").trigger("change");
    this.loadDataWarningUser();
  }

  searchWarningUser() {
    this.pageIndexWarningUser = 1;
    this.loadDataWarningUser();
  }

  loadDataWarningUser() {
    let query: any = {
      // keySearch:
      //   $('#serial3').val() && $('#serial3').val().trim() !== ''
      //     ? $('#serial3').val().trim().toUpperCase()
      //     : '',
      // agency: $('#Agency3').val() || '',
      // province: $('#Area3').val() || '',
      from: '',
      to: '',
      page: this.pageIndexWarningUser,
      page_size: this.pageSizeWarningUser,
    };
    // let time = $('#time3').val();
    // if (time) {
    //   query.from = time.split('-')[0].split('/').join('-').trim();
    //   query.to = time.split('-')[1].split('/').join('-').trim();
    // }

    this.loadingUserWarning = true;
    this.historyActiveService.getList(this.historyId, query).subscribe(
      (res) => {
        console.log('res', res)
        if (res.code === 1) {
          if (
            res.data.items !== null ||
            (res.data.items && res.data.items.length > 0)
          ) {
            this.data_warning_user = res.data.items.map((item: any) => {
              const tmpItem = Object.assign({}, item);
              let serial: any;
              if (item.stampCode && item.stampCode.split('-').length) {
                serial = this.formatSerial(
                  item.stampCode.split('-')[1],
                  item.stampCode.split('-')[0]
                );
                tmpItem.serial = serial;
              }

              return tmpItem;
            });
            this.total_warning_user = res.data.totalElement;
            this.loadingUserWarning = false;
            return;
          } else {
            this.data_warning_user = [];
            this.loadingUserWarning = false;
            this.total_warning_user = 0;
          }
        }
        this.data_warning_user = [];
        this.loadingUserWarning = false;
        this.total_warning_user = 0;
      },
      (error) => {
        this.data_warning_user = [];
        this.total_warning_user = 0;
        this.loadingUserWarning = false;
      }
    );
  }

  prePageWarningUser() {
    if (this.pageIndexWarningUser > 1) {
      this.pageIndexWarningUser = this.pageIndexWarningUser - 1;
      this.loadDataWarningUser();
    }
  }

  lastPageWarningUser() {
    if (
      this.pageIndexWarningUser * this.pageSizeWarningUser <
      this.total_warning_user
    ) {
      this.pageIndexWarningUser = this.pageIndexWarningUser + 1;
      this.loadDataWarningUser();
    }
  }

  inputPageWarningUser(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexWarningUser) {
      this.pageIndexWarningUser = page;
      this.loadDataWarningUser();
    }
  }

  listContent = [];
  stampList = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  errorMessage = [];
  // groupItems = [];
  isWithdrawal = false

  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    console.log(' this.listContent', this.listContent)
    console.log(' this.stampList', this.stampList)

    if (this.stampList.length == 0) {
      this.errorMessage = [];
    } else {
      console.log(' this.stampList', this.stampList)
      console.log('this.errorMessage', this.errorMessage)

      const convertListContent = []
      this.listContent.map((item) => {
        const prefix = item.split('-')[0]
        const number = Number(item.split('-')[1])
        console.log('item', item)
        console.log('prefix', prefix)
        convertListContent.push(`${prefix}-${number}-${number}`)

      })
      this.errorMessage = this.errorMessage.filter((val) => {
        if (val.parent) {
          if (convertListContent.includes(val.parent)) {
            return convertListContent.includes(val.serial)

          } else {
            return false
          }
        } else {
          return convertListContent.includes(val.serial)
        }
      })
    }
    // this.validateWithdrawal()

  }

  showModal() {
    // console
    const data = {
      id: 'myModalCrating',
      title: 'THÊM DANH SÁCH TEM THU HỒI',
      contentMess: 'Bạn chưa nhập tem',
      listContent: [],
    };
    this.boxRetalStamps.show(data);
  }

  loadDataTH(e) {
    console.log('e', e);

    const stampList = [];
    e.map((res) => {
      const splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = res.split(_serial)[0].slice(0, -1);
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      stampList.push(stamp);
    });
    // this.stampList = stampList;
    // console.log(' this.stampList', this.stampList)
    this.validateWithdrawal(stampList)
  }

  timeout: any = null;
  checkboxSigle: false

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked')
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 500)
  }

  changeCheckboxSigleValue() {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      console.log('asdfas', $('#checkboxSigleVal').val())

      let id = '';
      if ($('#checkboxSigleVal').val().search('http') !== -1) {
        const splitLink = $('#checkboxSigleVal').val().split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = $('#checkboxSigleVal').val()
      }

      if (id) {
        console.log('id', id)

        this.historyActiveService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.loadDataTH([val.data])
            } else {
              this.toastr.warning(this.translate.instant('CRATING_TEM_KHONG_HOP_LE'), this.translate.instant('CRATING_CANH_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translate.instant('CRATING_TEM_KHONG_HOP_LE'), this.translate.instant('CRATING_CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      $('#checkboxSigleVal').val('')

    }, 200);
  }

  changeWithdrawal() {
    if (this.loading_left) {
      this.toastr.warning(this.translate.instant('DANG_TAI_DU_LIEU'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.isDistribution = false;
      this.isList = false;
      this.isWithdrawal = true;
    }
  }

  validateWithdrawal(stampList) {
    // console.log(111, this.stampList);
    if (stampList.length <= 0) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM'), this.translate.instant('CRATING_CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    let body = [];
    // this.errorMessage = [];
    stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast)
      })
    })

    console.log('body', body);
    this.historyActiveService.validateWithdrawal(body).subscribe(
      (res) => {
        console.log(111);
        // this.stampList = []
        res.data.items.map((val) => {
          let check = _.find(this.stampList, {
            prefix: val.takeBackData.prefix,
            serialFirst: val.takeBackData.idStart,
            serialLast: val.takeBackData.idEnd,
            bundleType: val.bundleType,
            listParent: val.listParent,
            takeBackData: val.takeBackData,
            errMsg: val.errMsg,

          })
          if (!check) {
            this.listContent.push(val.takeBackData.stampRequest);
            console.log('this.listContent', this.listContent)
            console.log('val.takeBackData.stampRequest', val.takeBackData.stampRequest)
            this.stampList.push({
              prefix: val.takeBackData.prefix,
              serialFirst: val.takeBackData.idStart,
              serialLast: val.takeBackData.idEnd,
              bundleType: val.bundleType,
              listParent: val.listParent,
              takeBackData: val.takeBackData,
              errMsg: val.errMsg,

            })
          } else {
            this.toastr.warning(`${this.translate.instant('CRATING_TEM')} ${val.takeBackData.stampRequest} ${this.translate.instant('DA_TON_TAI_TRONG_DAI')} ${val.takeBackData.prefix}-${val.takeBackData.idStart}-${val.takeBackData.idEnd}`, this.translate.instant('CRATING_CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

        })
        console.log(' this.stampList', this.stampList);
        // check trung temp
        const err = []
        this.stampList.map((itemVal) => {
          if (res.code === 1) {
            if (itemVal.errMsg) {
              err.push({
                parent: '',
                serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                mess: `${itemVal.errMsg}`,
              })
            }
          }

          if (itemVal.listParent.length > 0) {
            itemVal.listParent.map((itemParent) => {
              const checkTr = _.find(this.stampList, {
                'prefix': itemParent.prefix,
                'serialFirst': itemParent.number,
                'serialLast': itemParent.number
              });
              if (checkTr) {
                err.push({
                  parent: `${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                  serial: `${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd}`,
                  mess: `${this.translate.instant('TEM_CON')} ${itemVal.takeBackData.prefix}-${itemVal.takeBackData.idStart}-${itemVal.takeBackData.idEnd} ${this.translate.instant('DA_THUOC_TEM_CHA')} ${itemParent.prefix}-${itemParent.number}-${itemParent.number}`,
                })
              }
              console.log('checkTr', checkTr)

            })
          }
          this.errorMessage = err
        })

        if (res.code === 1) {
          // this.stampList.map((val) => {
          //   if (val.errMsg) {
          //     this.errorMessage.push({
          //       serial: `${val.takeBackData.stampRequest}`,
          //       mess: `${val.errMsg}`,
          //     })
          //   }
          //
          // })


          // this.stampList = stampList;
          // if (this.errorMessage.length === 0) {
          //   this.listContent = [];
          //   this.stampList = [];
          //   this.toastr.success('Cập nhật thành công', 'Thông báo', {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //   });
          // }

          // this.reset(this.formCratingBatch.value.is_cratingStamps);
          // this.loadDataParent.emit(true);
        } else {
          this.toastr.warning(res.message, this.translate.instant('CRATING_CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, this.translate.instant('CRATING_CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  takeBackList() {
    // if (_.isEmpty(this.singleTakeBack)) {
    //   if (this.list_id.length <= 0) {
    //     this.toastr.warning('Bạn chưa chọn tem', 'Thông báo:', {
    //       timeOut: 4000,
    //       positionClass: 'toast-top-right',
    //     });
    //     return;
    //   }
    // }
    this.returnStampList.show();
  }

  resetFormWithdrawal() {
    this.formWithdrawal.reset();
    this.checkboxSigle = false
    this.listContent = [];
    this.stampList = [];
    this.errorMessage = [];
  }

  submitFormWithdrawal() {
    console.log(111, this.stampList);
    if (this.stampList.length <= 0) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM'), this.translate.instant('CRATING_CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (this.errorMessage.length > 0) {
      this.toastr.warning(this.translate.instant('TEM_LOI_CHUA_DUOC_XU_LY'), this.translate.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    let body = [];
    this.stampList.map((res) => {
      body.push({
        prefix: res.prefix,
        idStart: Number(res.serialFirst),
        idEnd: Number(res.serialLast),
        bundleType: Number(res.bundleType)

      })
    })

    console.log('body', body);
    // return;
    this.historyActiveService.withdrawal({ items: body }).subscribe(
      (res) => {
        if (res.code === 1) {
          this.returnStampList.hide()
          this.listContent = [];
          this.stampList = [];
          if (res.data.fail > 0) {
            this.toastr.warning(`${this.translate.instant('CAP_NHAT_THANH_CONG')} ${res.data.success}, ${this.translate.instant('THAT_BAI')} ${res.data.fail}`, this.translate.instant('CRATING_CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastr.success(`${this.translate.instant('CAP_NHAT_THANH_CONG')} ${res.data.success}, ${this.translate.instant('THAT_BAI')} ${res.data.fail}`, this.translate.instant('THONG_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }

          this.formWithdrawal.reset();
        } else {
          this.toastr.warning(res.message, this.translate.instant('CRATING_CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      (error) => {
        this.toastr.warning(`${error.message}`, this.translate.instant('CRATING_CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    // }
  }

  bsModalDownload: BsModalRef;

  showDownloadBatch(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }

  downloadBatch() {
    const timePicker = $('.timePicker2');
    let timeData = {
      startDate: timePicker.val().split('-')[0]
        ? timePicker.val().split('-')[0].trim()
        : '',
      endDate: timePicker.val().split('-')[1]
        ? timePicker.val().split('-')[1].trim()
        : '',
    }
    if (!timePicker.val()) {
      this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_THOI_GIAN'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    } else {
      this.batchService.getTokenDownloadBatchPP(timeData).subscribe((data) => {
        data._body.text().then((val) => {
          console.log('data', val)
          if (/^[\],:{}\s]*$/.test(val.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

            this.toastr.warning(`${JSON.parse(val).message}`, this.translate.instant('CRATING_CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            //the json is ok
            console.log(1111)
          } else {
            console.log(22222)
            this.batchService.saveToFileSystem(data, 'application/vnd.ms-excel', 'Danh sách phân phối.xlsx')
            //the json is not ok
          }
        })
      });
    }

  }

  public dataStampHistoryActive: any;

  viewDetail(item, i) {
    this.resetCheckbox();
    this.pageIndexStamp = 1;
    this.item_active = i;
    this.item_detail2 = item;
    if (this.isDistribution == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_PHAN_PHOI_DA_BI_HUY'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    this.isDistribution = false
    // @ts-ignore
    this.historyActiveService
      .distributeDetail(this.batchId, item.batchActionId)
      .subscribe((res) => {
        const listDistribute = res.data;
        this.checkButtonDistri = res.data.allActive;
        this.item_detail = listDistribute;

        if (this.item_detail && this.item_detail.warrantyReminderConfig) {
          const config = this.item_detail.warrantyReminderConfig;
          this.item_detail.is_override = true;
          if (config.reminderMaintain) {
            this.item_detail.is_maintenance_reminder = config.reminderMaintain.isSelect;
            this.item_detail.maintenance_mode = config.reminderMaintain.mode ? config.reminderMaintain.mode.toLowerCase() : null;
            this.item_detail.maintenance_cycle = config.reminderMaintain.numberTimeNotify;
            this.item_detail.is_extend_maintenance = config.reminderMaintain.reminderContinue;
            this.item_detail.extend_limit = config.reminderMaintain.numberOfLimit;
            if (config.reminderMaintain.timeType === 'DAY') this.item_detail.maintenance_cycle_unit = 'days';
            if (config.reminderMaintain.timeType === 'MONTH') this.item_detail.maintenance_cycle_unit = 'months';
            if (config.reminderMaintain.timeType === 'YEAR') this.item_detail.maintenance_cycle_unit = 'years';
          }
          if (config.reminderExpired) {
            this.item_detail.is_expired_reminder = config.reminderExpired.isSelect;
            this.item_detail.expired_mode = config.reminderExpired.mode ? config.reminderExpired.mode.toLowerCase() : null;
            this.item_detail.expired_cycle = config.reminderExpired.numberTimeNotify;
            if (config.reminderExpired.timeType === 'DAY') this.item_detail.expired_cycle_unit = 'days';
            if (config.reminderExpired.timeType === 'MONTH') this.item_detail.expired_cycle_unit = 'months';
            if (config.reminderExpired.timeType === 'YEAR') this.item_detail.expired_cycle_unit = 'years';
          }
        }

        if (this.item_detail.documents == null) {
          console.log(' nul 123123');
          this.listImage = [];
          console.log('res2222', this.listImage);
        } else {
          this.listImage = this.item_detail.documents.items;
          console.log(' not nul 123123');
          console.log('res3333', this.listImage);
        }

        this.loadListStamp(item.batchActionId)
        // this.formCratingBatch.controls.name.setValue(this.item_detail.name);
        // this.formCratingBatch.controls.note.setValue(this.item_detail.note);

        // this.listImageDistribution = [];
        // if (this.item_detail.document && this.item_detail.document.items) {
        //   this.item_detail.document.items.map((res) => {
        //     this.listImageDistribution.push({
        //       id: res.id,
        //       url: res.url,
        //     })
        //   })
        // }

        // listImageDistribution
      });

    this.isList = true;
  }

  validateCheckButtonDistribution(item_detail) {
    console.log('itema', item_detail)
    this.historyActiveService.validateButtonDistribution(item_detail.batchActionId).subscribe((res) => {
      if (res.code !== 1) {
        this.errorButtonValidate = res.message
        this.buttonDistribution.show();
      } else {
        this.dataStampHistoryActive = res.data.items;
        this.dataStampHistoryActive.map((res) => {
          this.formatSerial(res.idStart, res.prefix)
          this.formatSerial(res.idEnd, res.prefix)

        })
        this.isDistribution = true
        setTimeout(() => {
          this.boxStampDistribution.setData2(
            this.dataStampHistoryActive,
            this.dataStampHistoryActive[0].bundleType
          );
        }, 500);
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    })
  }

  public detailStamp: any;

  openModalCancelActive(item: any) {
    this.confirmCancelActive.show();
    this.detailStamp = item.id
  }

  closeModalCancelActive(param: any) {
    if (param === 'warning') {
      this.warningCancelActive.hide();
    } else {
      this.confirmCancelActive.hide();
    }
  }

  confirmModalCancelActive() {
    this.historyActiveService.deleteStamp(this.detailStamp).subscribe((res) => {
      if (res.status === 200) {
        if (res.code === 1) {
          this.toastr.error(this.translate.instant('XOA_THANH_CONG'), this.translate.instant('THONG_BAO'), {
            timeOut: 3000, positionClass: 'toast-bottom-right',
          })
          this.confirmCancelActive.hide();
        } else if (res.code === 403) {
          this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
            timeOut: 3000, positionClass: 'toast-bottom-right',
          })
          this.confirmCancelActive.hide();
        } else {
          this.confirmCancelActive.hide();
          this.warningCancelActive.show();
        }
      } else {
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 3000, positionClass: 'toast-bottom-right',
        })
        this.confirmCancelActive.hide();
      }
      setTimeout(() => {
        this.loadListStamp(this.item_detail2.batchActionId);
        this.fetch();
      }, 200)
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 3000, positionClass: 'toast-bottom-right',
      })
    })
  }
  public messageExport;

  exportDetailCode() {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const data_filter: any = {
      'batchActionId': this.item_detail2.batchActionId
    };
    const body = {
      exportTypeEnum: 'ALL_STAMP_IN_BATCH_ACTION',
      fields: data_filter
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY_XUAT_FILE');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/historyActive/historyActive.component.ts